import { render, staticRenderFns } from "./PreSurveyQuestion.vue?vue&type=template&id=326a27a6&scoped=true"
import script from "./PreSurveyQuestion.vue?vue&type=script&lang=js"
export * from "./PreSurveyQuestion.vue?vue&type=script&lang=js"
import style0 from "./PreSurveyQuestion.vue?vue&type=style&index=0&id=326a27a6&prod&lang=css"
import style1 from "./PreSurveyQuestion.vue?vue&type=style&index=1&id=326a27a6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "326a27a6",
  null
  
)

export default component.exports